module.exports = __webpack_public_path__ + "img/phone-pic.abe1e80.webp";